import PropTypes from 'prop-types';
import React from 'react';
import { setClassNames } from 'ddc-classnames-js';
import { featureIcons } from '../global-constants.js';

import '../global-sass/main.scss';

const renderFeatures = (features, isFullWidthLayout) => {
	const topFeatures = features;

	return topFeatures.map((id) => {
		const iconType =
			// featureIcons map can't use apostrophes (they're in single quote strings), so feature names use &apos; instead
			featureIcons.get(id[1].toLowerCase().replace("'", '&apos;')) ||
			'checkmark-sm';
		const iconClasses = `ddc-icon ddc-icon-${iconType} text-muted pr-3`;
		return (
			<li
				className={setClassNames([
					'mb-3',
					'd-flex',
					'align-items-center',
					isFullWidthLayout === true ? 'mr-4' : ''
				])}
				key={id[0]}
			>
				<i className={iconClasses} aria-hidden="true" />
				{id[1]}
			</li>
		);
	});
};

export default class HighlightedFeatures extends React.Component {
	render() {
		const { features, isFullWidthLayout } = this.props;

		if (features.length === 0) {
			return null;
		}

		return (
			<ul
				className={setClassNames([
					'list-unstyled',
					'line-height-condensed',
					'mb-0',
					isFullWidthLayout === true
						? 'hl-features-col-full-width'
						: ''
				])}
			>
				{renderFeatures(features, isFullWidthLayout)}
			</ul>
		);
	}
}

HighlightedFeatures.propTypes = {
	features: PropTypes.arrayOf(PropTypes.string),
	isFullWidthLayout: PropTypes.bool
};

HighlightedFeatures.defaultProps = {
	features: [],
	isFullWidthLayout: false
};
